module.exports = "<xo-generic-error ng-if=shouldRender token=token></xo-generic-error>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-error/template.html
// module id = ./pages/xo-generic-error/template.html
// module chunks = 1